import { useCallback, useEffect } from 'react';

import { useData } from '../../shared/hooks/use-data';
import { ListItem } from './list-item/list-item';
import { StyledListContainer } from './list.style';

export const List = () => {
    const { data, selectedDataItem } = useData();

    useEffect(() => {
        srcollList();
    }, [selectedDataItem]);

    const srcollList = useCallback(() => {
        if (!selectedDataItem) return;

        const index = data.findIndex((item) => selectedDataItem.id === item.id);

        if (index === -1) return;

        const container = document.querySelector('[data-list-container]') as HTMLElement;

        if (!container) return;

        let topPosition = 0;

        if (index !== 0) {

            for (let i = 0; i < index; i++) {
                const listItem = document.getElementById(`list-item-${i}`);

                if (!listItem) return;

                const listItemHeight = listItem.offsetHeight;

                topPosition += listItemHeight;

            }
        }

        container.scrollTo({
            top: topPosition,
            behavior: 'smooth'
        });

    }, [selectedDataItem])

    return (
        <StyledListContainer
            data-list-container="true"
            $width="35%">
            {data.map((item, index) => {
                return (
                    <div
                        id={`list-item-${index}`}
                        key={item.id}>
                        <ListItem
                            item={item}
                            key={item.id} />
                    </div>
                )
            })
            }
        </StyledListContainer >
    )
};